export default __webpack_public_path__ + "static/media/github-1-white.5a1e0458.svg";